// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__l6k0z","header":"ReportDetails_header__1lESd","title":"ReportDetails_title__3zsCl","left":"ReportDetails_left__38YZ9"};